import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import PublicRoute from './components/PublicRoute';
import Header from './components/Header';
import Login from './pages/Login';
import TwoFactorAuth from './components/TwoFactorAuth';
import Dashboard from './pages/Dashboard';
import Domains from './pages/Domains';
import Tags from './pages/Tags';
import './styles/App.css';
import DomainDetails from './pages/DomainDetails';
import UrlDetails from './pages/UrlDetails';
import Admin from './pages/Admin';
import AdminEmail from './pages/AdminEmail';
import Account from './pages/Account';
import Layout from './components/Layout';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="app">
          <Routes>
            {/* Public routes - no header */}
            <Route path="/login" element={
              <PublicRoute>
                <Login />
              </PublicRoute>
            } />
            <Route path="/2fa" element={
              <PublicRoute>
                <TwoFactorAuth />
              </PublicRoute>
            } />
            {/* Protected routes - with persistent header/sidebar */}
            <Route path="/dashboard" element={
              <ProtectedRoute>
                <Layout>
                  <Dashboard />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/domains" element={
              <ProtectedRoute>
                <Layout>
                  <Domains />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/domains/:domain" element={
              <ProtectedRoute>
                <Layout>
                  <DomainDetails />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/urls/:url" element={
              <ProtectedRoute>
                <Layout>
                  <UrlDetails />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/slugs/:slug" element={
              <ProtectedRoute>
                <Layout>
                  <UrlDetails kind="slug" />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/tags" element={
              <ProtectedRoute>
                <Layout>
                  <Tags />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/account" element={
              <ProtectedRoute>
                <Layout>
                  <Account />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/admin" element={
              <ProtectedRoute>
                <Layout>
                  <Admin />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/admin/email" element={<ProtectedRoute><AdminEmail /></ProtectedRoute>} />
            <Route path="/*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
